import { ChatMessage, MessageType, NotificationService } from '@talon/web/lib/api';
import { makeObservable, observable, runInAction } from 'mobx';
import { BaseStore } from './baseStore'; // for some dumb reason, these have to be imported individually
import { RootStore } from './rootStore'; // for some dumb reason, these have to be imported individually

export class NotificationStore extends BaseStore {
  currentNotification: ChatMessage | undefined = undefined;
  notifications: ChatMessage[] = [];

  page = 1;
  limit = 10;
  total = 0;
  unreadCount = 0;

  constructor(rootStore: RootStore) {
    super(rootStore);

    makeObservable(this, {
      currentNotification: observable,
      notifications: observable,
      page: observable,
      limit: observable,
      total: observable,
      unreadCount: observable,
    });
  }

  setPage = (page: number) => {
    runInAction(() => (this.page = page));
  };

  handleMessage = (msg: ChatMessage) => {
    const NOTIFICATION_TYPES: MessageType[] = [
      MessageType.NOTIFICATION,
      MessageType.PERFORMER_CONTRACT_DECLINED,
    ];
    if (msg && NOTIFICATION_TYPES.includes(msg.type as MessageType)) {
      // List is first-in, last-out
      const updatedMsgs = [msg].concat(
        this.notifications.length + 1 > this.limit ? this.notifications.slice(0, -1) : this.notifications
      );

      runInAction(() => {
        this.notifications = updatedMsgs;
        if (msg.unread) this.unreadCount += 1;
      });

      return msg;
    }
  };

  markAsRead = async () => {
    await NotificationService.bulkUpdate({
      ids: this.notifications.map((n) => n.id),
      unread: false,
    });

    const { count } = await NotificationService.getUnreadCount();
    runInAction(() => {
      this.unreadCount = count;
    });
  };

  list = async () => {
    try {
      const [{ notifications, page, total }, { count }] = await Promise.all([
        NotificationService.listNotifications(undefined, this.limit, this.page),
        NotificationService.getUnreadCount(),
      ]);

      runInAction(() => {
        this.notifications = notifications;
        this.page = page;
        this.total = total;
        this.unreadCount = count;
      });

      return notifications;
    } catch (e) {
      this.handleError(e);
    }
  };

  get = async (notificationId: string) => {
    try {
      const { notification } = await NotificationService.getNotification(notificationId, 'user');

      runInAction(() => {
        this.currentNotification = notification;
      });

      return notification;
    } catch (e) {
      this.handleError(e);
    }
  };
}
